const RELOAD_ATTEMPTED_KEY = "stale-client-reload-attempted";
const WORKBOX_PRECACHE_PREFIX = "workbox-precache";

const reloadAlreadyAttempted = (): boolean => {
  try {
    return sessionStorage.getItem(RELOAD_ATTEMPTED_KEY) !== null;
  } catch {
    return true;
  }
};

const markReloadAttempted = (): boolean => {
  try {
    sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, "true");
    return true;
  } catch {
    return false;
  }
};

const unregisterServiceWorkers = async (): Promise<void> => {
  if (!("serviceWorker" in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations.map((registration) => registration.unregister()),
  );
};

const deleteAppShellPrecaches = async (): Promise<void> => {
  if (!("caches" in window)) return;
  const cacheNames = await caches.keys();
  await Promise.all(
    cacheNames
      .filter((name) => name.startsWith(WORKBOX_PRECACHE_PREFIX))
      .map((name) => caches.delete(name)),
  );
};

export const reloadOnceWithFreshClient = async (): Promise<boolean> => {
  if (!navigator.onLine || reloadAlreadyAttempted() || !markReloadAttempted())
    return false;
  try {
    await unregisterServiceWorkers();
    await deleteAppShellPrecaches();
  } catch {
    // A plain reload still refetches index.html when no service worker controls the page.
  }
  window.location.reload();
  return true;
};

export const clearStaleClientReloadGuard = (): void => {
  try {
    sessionStorage.removeItem(RELOAD_ATTEMPTED_KEY);
  } catch {}
};
